<template>
  <div>
    <b-container>
      <div class="mt-4 mb-2 d-flex justify-content-between">
        <back-arrow :params="fromDashboard ? {} : {operationId: operationId}"
                    :routeBack="fromDashboard ? 'Dashboard' : 'OperationShowTasks'"
                    :title="operationTask.name"/>
        <div>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('OperationTask.name.label') }}</div>
                  <div> {{ operationTask.name }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('OperationTask.status.label') }}</div>
                  <div> {{ $t(operationTask.status.text) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('OperationTask.deadlineDate.label') }}</div>
                  <div> {{ operationTask.date }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('OperationTask.alertType.label') }}</div>
                  <div> {{ operationTask.alertToString }}</div>
                </div>
              </div>
              <div v-if="operationTask.description !== null" class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('OperationTask.description.label') }}</div>
                  <div> {{ operationTask.description }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('OperationTask.assignedTo.label') }}</div>
                  <div v-if="operationTask.assignedTo">
                    {{ operationTask.assignedTo.firstName + ' ' + operationTask.assignedTo.lastName }}
                  </div>
                  <div v-else class="text-muted">
                    {{ $t('OperationTask.assignedTo.none') }}
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="operationTask"
      controllerName="operationTask"
      itemSingularName="tâche"
      itemSingularNameUpp="Tâche"
      @didDeleteItem="didDeleteOperationTask()">
    </Item-delete-modal>
  </div>
</template>

<script>
import BackArrow from "../../components/b122/BackArrow";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import api from "../../services/api";

export default {
  name: "OperationTaskShow",

  components: {
    BackArrow,
    ItemDeleteModal
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      operationTaskId: this.$route.params.operationTaskId,
      fromDashboard: this.$route.params.fromDashboard,
      operationTask: {}
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchOperationTask()
    },

    fetchOperationTask() {
      api
        .get(`/operationTask/${this.operationTaskId}`)
        .then(response => {
          this.operationTask = response.data
          this.operationId = response.data.operation.id
        })
        .catch((error) => {
          this.$router.push({
            name: this.fromDashboard ? 'Dashboard' : 'OperationShowTasks',
            params: this.fromDashboard ? {} : {
              operationId: this.operationId,
              currentSection: 3,
              message: error.response.data.message
            }
          })
        })
    },

    clickOnEditBtn() {
      if (this.fromDashboard) {
        this.$router.push({
          name: 'OperationTaskCreateEditFromDashboard',
          params: {
            fromDashboard: true,
            operationTaskId: this.operationTaskId,
            operationId: this.operationId
          }
        })
      } else {
        this.$router.push({
          name: 'OperationTaskCreateEdit',
          params: {
            fromDashboard: false,
            operationTaskId: this.operationTaskId,
            operationId: this.operationId
          }
        })
      }
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteOperationTask() {
      this.$router.push({
        name: this.fromDashboard ? 'Dashboard' : 'OperationShowTasks',
        params: this.fromDashboard ? {} : {
          operationId: this.operationId,
          currentSection: 3
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationTask/OperationTaskShow.vue